import React, {useState} from "react";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Form from "react-bootstrap/Form";
import Alert from "@mui/material/Alert";
import SaveIcon from "@mui/icons-material/Save";

import { selectToken } from "../../storeConfig/reducers/loginReducer";
import { useSelector } from "react-redux";
import { postChangePassword } from "../../services/perfil";

function AlterarSenha() {
	const token = useSelector(selectToken); 

	const [responseSenha, setResponseSenha] = useState();
	const [isLoadingSenha, setIsLoadingSenha] = useState(false);
	const [senhaAtual, setSenhaAtual] = useState("");
	const [novaSenha, setNovaSenha] = useState("");
	const [confirmarNovaSenha, setConfirmarNovaSenha] = useState("");

	const [errorSenha, setErrorSenha] = useState({
		current_password: false,
		new_password: false,
		re_new_password: false,
	});

	const [helperTextSenha, setHelperTextSenha] = useState({
		current_password: "",
		new_password: "",
		re_new_password: "",
	});

	const validateHelperTextSenha = (errors) => {
		setHelperTextSenha({
			current_password: errors.current_password,
			new_password: errors.new_password,
			re_new_password: errors.re_new_password,
		});
	};

	const validateErrorSenha = (errors) => {
		let aux = {
			current_password: errors.current_password ? true : false,
			new_password: errors.new_password ? true : false,
			re_new_password: errors.re_new_password ? true : false,
		};

		setErrorSenha(aux);
	};

	const alterarSenha = (senhas) => {
		postChangePassword(token, senhas)
			.then(function (response) {
				if (response.status === 204) setResponseSenha(true);

				setIsLoadingSenha(false);
			})
			.catch(function (errors) {
				console.log(errors);

				validateHelperTextSenha(errors.response.data);
				validateErrorSenha(errors.response.data);
				setIsLoadingSenha(false);
			});
	};

	const handleSubmitSenha = (e) => {
		e.preventDefault();
		setIsLoadingSenha(true);

		const senhas = {
			current_password: senhaAtual,
			new_password: novaSenha,
			re_new_password: confirmarNovaSenha,
		};

		alterarSenha(senhas);
	};

	return (
		<Form noValidate onSubmit={handleSubmitSenha}>
			<section className="mt-5">
				<h4>Alterar Senha</h4>

				<div className="row">
					<div className="my-2 col-sm-12 col-md-12 col-lg-12">
						<TextField
							fullWidth
							label="Senha Atual"
							type="password"
							helperText={helperTextSenha.current_password}
							error={errorSenha.current_password}
							value={senhaAtual}
							onChange={(e) => setSenhaAtual(e.target.value)}
						/>
					</div>
					<div className="my-2 col-sm-12 col-md-6 col-lg-6">
						<TextField
							fullWidth
							label="Nova Senha"
							type="password"
							helperText={helperTextSenha.new_password}
							error={errorSenha.new_password}
							value={novaSenha}
							onChange={(e) => setNovaSenha(e.target.value)}
						/>
					</div>
					<div className="my-2 col-sm-12 col-md-6 col-lg-6">
						<TextField
							fullWidth
							label="Confirme a nova senha"
							type="password"
							helperText={helperTextSenha.re_new_password}
							error={errorSenha.re_new_password}
							value={confirmarNovaSenha}
							onChange={(e) =>
								setConfirmarNovaSenha(e.target.value)
							}
						/>
					</div>
				</div>

				<div className="d-flex justify-content-center mt-3">
					<Button
						variant="outlined"
						type="submit"
						size="medium"
						disabled={isLoadingSenha}
						startIcon={!isLoadingSenha && <SaveIcon />}
					>
						Salvar
					</Button>
				</div>

				{responseSenha && (
					<div className="d-flex justify-content-center mt-3">
						<Alert
							severity="success"
							onClose={() => {
								setResponseSenha(false);
							}}
							sx={{ maxWidth: "500px" }}
						>
							Senha modificada com sucesso.
						</Alert>
					</div>
				)}
			</section>
		</Form>
	);
}

export default AlterarSenha;
